import React, { useState, useEffect } from 'react';
import { Container, Image, Button, Spinner } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import PartnerHeader from './PartnerHeader';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import './camp-notes.css';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName, formatDate } from '../../../utils/utils';
import Blue_Badge from '../../../assets/icon/Verified-badge.svg';
import Edit_Icon from '../../../assets/icon/Edit.svg';
import View_Icon from '../../../assets/icon/View.svg';
import Delete_Icon from '../../../assets/icon/Delete.svg';
import Cross_Badge from '../../../assets/icon/Unverified.svg';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import WriteNotesModal from './WriteNotesModal';
import DeleteNotesModal from './DeleteNotesModal';
import RoundButton from '../../common/RoundButton';
import { notesViewModel } from './notes.view.model';
import ViewNoteModal from './ViewNoteModal';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import CampRestrictModal from './CampRestrictModal';
import IIcon from '../../../assets/icon/PRINT.svg';
import { Typography } from '@mui/material';
import CampNoDataTooltip from './camp_tour/CampNoDataTooltip';
import NoNotesImg from '../../../assets/images/tour/kid_notes.svg';

const CampCaptainNotes = () => {
  const _PAGE_LIMIT = 10;
  const history = useHistory();
  const kid = JSON.parse(history?.location?.state?.kid);
  const { school } = useAuth();
  const [showWriteNoteModal, setShowWriteNoteModal] = useState(false);
  const [showDeleteNoteModal, setShowDeleteNoteModal] = useState(false);
  const [showViewNoteModal, setShowViewNoteModal] = useState(false);
  const [showRestrictCampModal, setShowRestrictCampModal] = useState(false);
  const [notesList, setNotesList] = useState([]);
  const [viewNoteText, setViewNoteText] = useState('');
  const [type, setType] = useState('new');
  const [note, setNote] = useState(null);
  const [deleteNoteId, setDeleteNoteId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);

  const NoNotes = [
    {
      element: '#no-notes',
      intro: `
      <div class="custom-tour-step">
        <img src="${NoNotesImg}" alt="Camp Master" class="tour-avatar" />
        <h3>Captain Notes</h3>
        <p>Special space to read helpful notes from Captain, guiding you on your adventures!</p>
      </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  useEffect(() => {
    changeBodyClassName([bg.WHITE]);
    if (kid.id) getNotes();
  }, []);

  const handleWriteNote = () => {
    if (school?.subcription_type !== 'premium') {
      setShowRestrictCampModal(true);
      return;
    }
    setType('new');
    setNote(null);
    setShowWriteNoteModal(true);
  };

  const handleEditNote = (note) => {
    setType('edit');
    setNote(note);
    setShowWriteNoteModal(true);
  };

  const handleDeleteNote = (noteId) => {
    setDeleteNoteId(noteId);
    setShowDeleteNoteModal(true);
  };

  const handleViewNote = (text) => {
    setShowViewNoteModal(true);
    setViewNoteText(text);
  };

  const getNotes = async () => {
    const data = {
      dependent_id: kid?.id,
      group_id: kid?.profile?.group?.id,
    };

    try {
      const res = await notesViewModel.getNotes(data);
      if (res.length !== 0) {
        setNotesList(res);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleDelete = () => {
    notesViewModel
      .deleteNote(deleteNoteId)
      .then((res) => {
        setDeleteNoteId(null);
        setShowDeleteNoteModal(false);
        getNotes();
      })
      .catch((err) => {
        console.log(err);
        setShowDeleteNoteModal(false);
      });
  };

  const handleGobackClick = () => {
    history.goBack();
  };

  const handleNoDataClick = () => {
    setShowNoDataTooltip(true);
  };

  return (
    <div className="treehouse-details partner-wrapper-main">
      <PartnerHeader />
      <CampNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={NoNotes}
      />
      <CampRestrictModal
        showModal={showRestrictCampModal}
        setShowModal={setShowRestrictCampModal}
      />
      <WriteNotesModal
        type={type}
        note={note}
        selectedDependent={kid}
        showModal={showWriteNoteModal}
        setShowModal={setShowWriteNoteModal}
        getNotes={getNotes}
      />
      <DeleteNotesModal
        showModal={showDeleteNoteModal}
        setShowModal={setShowDeleteNoteModal}
        handleDelete={handleDelete}
      />
      {showViewNoteModal && (
        <ViewNoteModal
          text={viewNoteText}
          selectedDependent={kid}
          showModal={showViewNoteModal}
          setShowModal={setShowViewNoteModal}
        />
      )}
      <div
        className="treehouse-back new-payment-plan-back-btn"
        role="button"
        onClick={handleGobackClick}
      >
        <span id="new-back-btn" className="back-btn">
          <HiOutlineChevronLeft />
        </span>
      </div>
      <Container>
        <div
          id="main-tree-detail-sec"
          className="treehouse-details-inner threehouse_notes"
        >
          <div>
            <div className="treehouse-details-header">
              <h4>Notes</h4>
              <div className="grade-dropdown">
                <div className="filter-container">
                  <div className="filter-tag">
                    {school?.user_type === 'school_teacher' && (
                      <RoundButton
                        type="button"
                        label="Write Note"
                        className="transparent-button d-sm-block notes-top-btn"
                        onClick={handleWriteNote}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="treehouse-right-action">
              {!isLoading ? (
                notesList.length > 0 ? (
                  <div className="table-container">
                    <Table hover>
                      <thead>
                        <tr>
                          <th>Child</th>
                          <th>Notes</th>
                          <th>Date</th>
                          <th>
                            {school?.user_type === 'school_teacher'
                              ? 'Edit/View'
                              : 'View'}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {notesList.length
                          ? notesList.map((item, key) => {
                              return (
                                <tr key={key}>
                                  <td>
                                    <div
                                      className="kids_name_img"
                                      role="button"
                                      onClick={() =>
                                        history.push(`/${kid.username}`)
                                      }
                                    >
                                      <Image
                                        className="KidsAvtar"
                                        src={getUserProfileUrl(kid)}
                                        style={{ marginRight: 0 }}
                                      />
                                      {kid?.username}
                                      <Image
                                        className="blue_badge"
                                        src={
                                          kid?.profile?.is_activated
                                            ? Blue_Badge
                                            : Cross_Badge
                                        }
                                      />
                                    </div>
                                  </td>
                                  <td className="notes-text-truncate">
                                    {item?.content}
                                  </td>
                                  <td>{formatDate(item?.created_at)}</td>
                                  <td id="view-img-section">
                                    {school?.user_type === 'school_teacher' && (
                                      <Image
                                        className="add-pointer"
                                        src={Edit_Icon}
                                        onClick={() => handleEditNote(item)}
                                        alt="edit"
                                      />
                                    )}
                                    <Image
                                      className="write-notes add-pointer"
                                      onClick={() => handleViewNote(item)}
                                      src={View_Icon}
                                      alt="view"
                                    />
                                    {school?.user_type === 'school_teacher' && (
                                      <Image
                                        className="add-pointer"
                                        src={Delete_Icon}
                                        onClick={() =>
                                          handleDeleteNote(item?.id)
                                        }
                                        alt="delete"
                                      />
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          : ''}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div
                    className="insights-text no-data-found"
                    style={{ paddingTop: '75px' }}
                    id="no-notes"
                  >
                    <div className="text-wrapper">
                      <Image
                        src={IIcon}
                        alt="no-data"
                        className="add-pointer"
                        onClick={handleNoDataClick}
                      />
                      <Typography variant="body1" style={{ color: '#321b6d' }}>
                        No notes are available at the moment.
                      </Typography>
                    </div>
                  </div>
                )
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default CampCaptainNotes;
